import { Component, input } from '@angular/core';

/**
 * Grouping shell: title sits on a horizontal rule; content is projected.
 * Uses native fieldset/legend for semantics when a legend is provided.
 */
@Component({
  selector: 'kl-fieldset',
  standalone: true,
  templateUrl: './kl-fieldset.html',
  styleUrl: './kl-fieldset.scss',
})
export class KlFieldsetComponent {
  /** Visible title on the top line (e.g. translated string). */
  readonly legend = input('');
}
